<div class="thanks-page">
    <div class="container">
        <div class="row mt-5 pt-5 mb-5">
            <div class="col-sm-12">
                <div class="thanks-center">
                    <div class="heading-missingpets">
                        <h1 *ngIf="successContent">
                            {{ 'PUBLICATION_REMINDER_SUCCESS' | translate }}
                        </h1>
                        <h3 *ngIf="errorContent">
                            {{ 'PUBLICATION_ALREADY_EXTENDED' | translate }}
                        </h3>
                        <h3 *ngIf="missingexpiredContent">
                            {{ 'PUBLICATION_MISSINGLINK_EXPIRED' | translate }}
                        </h3>
                        <h3 *ngIf="foundexpiredContent">
                            {{ 'PUBLICATION_FOUNDLINK_EXPIRED' | translate }}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
</ngx-spinner>